import React, { useCallback, useEffect, useState } from 'react'
export function useDrag(
  initial: { x: number; y: number },
  bounds?: { width: number; height: number },
  size?: { width: number; height: number },
  getContainerRect?: () => { left: number; top: number }
) {
  const [pos, setPos] = useState(initial)
  const [drag, setDrag] = useState<{ dx: number; dy: number; active: boolean; originLeft: number; originTop: number }>({ dx: 0, dy: 0, active: false, originLeft: 0, originTop: 0 })

  const clamp = useCallback(
    (p: { x: number; y: number }) => {
      if (!bounds || !size) return p
      return {
        x: Math.max(0, Math.min(bounds.width - size.width, p.x)),
        y: Math.max(0, Math.min(bounds.height - size.height, p.y)),
      }
    },
    [bounds, size]
  )

  useEffect(() => setPos((p) => clamp(p)), [clamp])

  const start = useCallback((e: React.MouseEvent) => {
    // PROJ-072: Prevent event propagation to avoid Dialog/overlay interference
    e.preventDefault()
    e.stopPropagation()
    const origin = getContainerRect?.() || { left: 0, top: 0 }
    setDrag({ dx: e.clientX - origin.left - pos.x, dy: e.clientY - origin.top - pos.y, active: true, originLeft: origin.left, originTop: origin.top })
  }, [pos, getContainerRect])
  const move = useCallback((e: globalThis.MouseEvent) => {
    if (!drag.active) return
    setPos((p) => clamp({ x: e.clientX - drag.originLeft - drag.dx, y: e.clientY - drag.originTop - drag.dy }))
  }, [drag, clamp])
  const stop = useCallback(() => setDrag((d) => ({ ...d, active: false })), [])

  useEffect(() => {
    window.addEventListener('mousemove', move)
    window.addEventListener('mouseup', stop)
    return () => {
      window.removeEventListener('mousemove', move)
      window.removeEventListener('mouseup', stop)
    }
  }, [move, stop])

  return { pos, setPos, start }
}
